import NewPatientForm from "../components/PatientList/NewPatientForm";

export default function NewPatientPage(props) {
  return <NewPatientForm {...props} />;
}
